import { call, put, takeEvery, all } from 'redux-saga/effects';
import { Routine } from 'redux-saga-routines';
import { updateCandidateStatusRoutine } from './routines';
import { updateStatus } from '../../services/candidateService';
import { errorToast, successToast } from '../../common/helpers/toastrHelper';
import { CandidateStatus } from '../../common/enums/CandidateStatus';

function* updateCandidateStatus({ payload }: Routine<any>) {
  try {
    yield call(updateStatus, payload);
    yield put(updateCandidateStatusRoutine.success(payload));
    if (payload.status === CandidateStatus.Active) {
      yield call(successToast, 'Unarchived candidate(s)', 'toast.candidateUnarchivedSuccess');
    } else {
      yield call(successToast, 'Archived candidate(s)', 'toast.candidateArchivedSuccess');
    }
  } catch (error) {
    yield put(updateCandidateStatusRoutine.failure(error.message));
    yield call(errorToast, error.message);
  }
}

function* watchUpdateCandidateStatus() {
  yield takeEvery(updateCandidateStatusRoutine.TRIGGER, updateCandidateStatus);
}

export default function* bulkActionsSaga() {
  yield all([watchUpdateCandidateStatus()]);
}
